module.exports = __webpack_public_path__ + "static/media/banner_below_image_2.50f9247a.svg";